import gql from 'graphql-tag'
import * as React from 'react'
import { Query } from 'react-apollo'
import styled from 'styled-components'
import Select from 'web-makeup/dist/Select'
import Spin from 'web-makeup/dist/Spin'

import { GetAllCountries } from './../../typings/types'

const { Option } = Select

const StyledSelect = styled(Select as any)`
  /* without this the placeholder has no width dimension */
  width: 10rem;
`

export const GET_ALL_COUNTRIES = gql`
  query getAllCountries {
    allCountries {
      name
      code
    }
  }
`

class AllCountriesQuery extends Query<GetAllCountries.Query, GetAllCountries.Variables> {}

type Props = Partial<{
  value: string
  className: string
  onChange: (countryCode: string) => void
}>

const CountrySelect: React.SFC<Props> = ({ className, value, onChange }) => (
  <AllCountriesQuery query={GET_ALL_COUNTRIES}>
    {({ data, loading, error }) => {
      if (error) {
        return 'Country filter not available'
      }

      return (
        <Spin spinning={loading}>
          <StyledSelect
            className={className}
            allowClear
            showSearch
            value={value}
            placeholder="Country"
            onChange={onChange}
            optionFilterProp="children"
          >
            {data &&
              data.allCountries &&
              data.allCountries.map(({ code, name }) => (
                <Option key={code} value={code}>
                  {name}
                </Option>
              ))}
          </StyledSelect>
        </Spin>
      )
    }}
  </AllCountriesQuery>
)

export default CountrySelect



// WEBPACK FOOTER //
// ./src/components/CountrySelect/CountrySelect.tsx